import PictureCardInformation from './PictureCardInformation'
export default PictureCardInformation
